export default "/images/3a9e522b085a60198ee4218e0375d626.avif";